import { REGISTERED_TYPE, SANSHO_LEVEL, SupportSite } from 'constant';
import { Layout, LayoutProps, SiteList } from 'containers';
import { toast } from 'react-toastify';
// 2023/12/27 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 start
import NewentrantSendoff from 'pages/NewentrantSendoff';
import EducationStatus from 'pages/EducationStatus';
import SendPhoto from 'pages/EducationStatus/SendPhoto';
// 2023/12/27 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 end
import MapSite from 'containers/MapSite';
import { routes } from 'navigations/routers';
import { FC, useCallback, useEffect } from 'react';
import { generatePath, useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import type { AppDispatch } from 'redux/store';
import { getMapSite, getUserSiteCharge } from 'containers/SiteList/thunk';
import { userData } from '../../Login/selectors';
import { layoutSelector } from '../../../containers/Layout/selectors';

type Props = {};

const SupportSiteList: FC<Props> = () => {
  const history = useHistory();
  const { entity = SupportSite.CHARGE } = useParams<{ entity: SupportSite }>();
  const dispatch = useDispatch<AppDispatch>();
  const { kengen_code } = useSelector(userData);
  const { branchSelected } = useSelector(layoutSelector);

  const fetchApi = useCallback(async () => {
    switch (entity) {
      case SupportSite.CHARGE:
        if (kengen_code && ['A6', 'A7'].includes(kengen_code) && !branchSelected) return;
        return dispatch(
          getUserSiteCharge({
            sansho_level: SANSHO_LEVEL.DTC_01_01,
            registered_type: REGISTERED_TYPE.DTC_01_01,
          })
        );

      case SupportSite.AGENT:
        return dispatch(
          getUserSiteCharge({
            sansho_level: SANSHO_LEVEL.DTC_01_02,
            registered_type: REGISTERED_TYPE.DTC_01_02,
          })
        );
      case SupportSite.MAP:
        const resultAction = await dispatch(
          getMapSite({
            sansho_level: SANSHO_LEVEL.DTC_03_01,
            registered_type: REGISTERED_TYPE.DTC_03_01,
          })
        );
        if (getMapSite.rejected.match(resultAction)) {
          const payload = resultAction.payload as { message?: string };
          toast.error(payload?.message || 'エラーが発生しました。');
        }
        return resultAction;
      default:
        return;
    }
  }, [branchSelected, dispatch, entity, kengen_code]);

  useEffect(() => {
    fetchApi();
  }, [fetchApi]);
  const handleSelectedTab = useCallback(
    (entity) => {
      return history.replace(generatePath(routes.Home.path, { entity }));
    },
    [history]
  );

  return (
    <>
      <Layout
        tabs={tabs}
        onSelected={handleSelectedTab}
        defaultValue={entity}
        left
        right
        showButtonBranchSelect
      />
      {entity === SupportSite.CHARGE && <SiteList isGetStatusKy />}
      {entity === SupportSite.AGENT && <SiteList isGetStatusKy />}
      {entity === SupportSite.MAP && <MapSite />}
      {/* 2023/12/27 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 start */}
      {entity === SupportSite.EducationStatus && <EducationStatus />}
      {entity === SupportSite.NEW_ENTRANTSENDOFF && <NewentrantSendoff />}
      {/* 2023/12/27 Leading Win 教育機能対応 DXWEBEDU00100_教育実施状況確認 end */}
      {/* 2024/01/03 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 start */}
      {entity === SupportSite.SendPhoto && <SendPhoto />}
      {/* 2024/01/03 Leading Win 教育機能対応 DXWEBEDU00200_画像送付 end */}
    </>
  );
};
const tabs: LayoutProps['tabs'] = [
  { label: '担当現場一覧', key: SupportSite.CHARGE },
  { label: '代行現場一覧', key: SupportSite.AGENT },
  { label: 'マップ', key: SupportSite.MAP },
  // 2023/12/19 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ start
  // 2024/03/28 Leading Win 教育機能の非表示 start
  // { label: '新規・送出', key: SupportSite.EducationStatus },
  // 2024/03/28 Leading Win 教育機能の非表示 end
  // 2023/12/19 Leading Win 教育機能対応 DXWEBEFN00101_教育受講確認ダイアログ end
];

export default SupportSiteList;
